import { isServer } from '@/helpers/general';
import { UserInfoBannerMessage, UserInfoBannerSeverity, userInfoBannerFlagSchema } from './UserInfoBanner.types';

export const SEVERITY_BY_MESSAGE: Record<UserInfoBannerMessage, UserInfoBannerSeverity> = {
  operational_failure: 'error',
  system_error: 'error',
  service_disruption: 'error',
  minor_disruption: 'warning',
  degraded_performance: 'info',
  temporarily_affected: 'info',
  problem_fixed: 'positive',
};

const DISMISSED_STORAGE_KEY = 'userInfoBannerDismissed';

export const getActiveBanner = (flagValue: unknown) => {
  const parsed = userInfoBannerFlagSchema.safeParse(flagValue);
  return parsed.success ? parsed.data.banner : null;
};

// Dismissal is keyed to the active message so shipping a new variant re-shows
// the banner even if the previous one was dismissed.
export const checkIfDismissedInSession = (message: UserInfoBannerMessage): boolean => {
  if (isServer) return false;
  return sessionStorage.getItem(DISMISSED_STORAGE_KEY) === message;
};

export const saveDismissedInSession = (message: UserInfoBannerMessage) => {
  if (isServer) return;
  sessionStorage.setItem(DISMISSED_STORAGE_KEY, message);
};
